module.exports = __webpack_public_path__ + "static/media/ro.0fc592f2.svg";